const CalendarSlotsCardSkeleton = () => {
	return (
		<div className="w-full animate-pulse space-y-3 rounded-lg border bg-white p-4 shadow-sm md:w-fit">
			<div className="mx-auto h-5 w-52 rounded-md bg-gray-200 md:mx-0"></div>
			<div className="space-y-2">
				<div className="flex justify-between gap-2">
					<div className="flex items-center gap-2 pe-2">
						<div className="h-4 w-12 rounded-sm bg-gray-200"></div>
					</div>
					<div className="flex gap-1">
						<div className="size-6 rounded-md bg-gray-200"></div>
						<div className="size-6 rounded-md bg-gray-200"></div>
					</div>
				</div>
			</div>
		</div>
	);
};

export { CalendarSlotsCardSkeleton };
